// extracted by mini-css-extract-plugin
var _1 = "ViewingProfileDocumentsRow-moduleViewingProfileDocumentsRow__qx0nr TableComponent-modulerow__xPAo4";
var _2 = "ViewingProfileDocumentsRow-modulenameCell__DOQBq TableCellBase-moduleTableCellBase__GDcv6 TableCell-moduleTableCell__hIV2f";
export { _1 as "ViewingProfileDocumentsRow", _2 as "nameCell" }
